import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { SERVER_URL, isMobile } from '../../config';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import { fetchNoticeDetailData } from '../../services/noticeService';

import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';

import S from './Support.module.css';
import BackListBtn from '../../components/Button/BackListBtn';

const NoticeDetailPage = () => {

  const { idx } = useParams();
  const [ notice, setNotice ] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  useEffect(() => {
    const noticeDetailData = async () => {
      const ntData = await fetchNoticeDetailData(idx);
      setNotice(ntData);
    };

    noticeDetailData();
  }, []);

  return (
    <div>
      <HeaderComponents pageKey="support" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="support" />
        </div>
        <div className='com-content-wrap mt-200'>
          <div style={{minHeight:'650px'}}>
            <div className={S.ntTitle}>{notice.length > 0 ? notice[0].NT_TITLE : ''}</div>
            <div className={S.tableCont} dangerouslySetInnerHTML={{ __html: notice.length > 0 && notice[0].NT_CONTENT }} />
            <div className='flex-row center mt-100 mb-50'>
              <BackListBtn text='목록으로' path='/support/notice/1'/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoticeDetailPage;
